export function makeTableResizable() {
	var thElm;
	var startOffset;

	Array.prototype.forEach.call(document.querySelectorAll('.list_tbl th'), function(th) {
		th.style.position = 'relative';

		var grip = document.createElement('div');
		grip.innerHTML = '&nbsp;';
		grip.style.top = 0;
		grip.style.right = 0;
		grip.style.bottom = 0;
		grip.style.width = '5px';
		grip.style.position = 'absolute';
		grip.style.cursor = 'col-resize';
		grip.addEventListener('mousedown', function(e) {
			thElm = th;
			startOffset = th.offsetWidth - e.pageX;
		});

		th.appendChild(grip);
	});

	document.addEventListener('mousemove', function(e) {
		if (thElm) {
			thElm.style.width = startOffset + e.pageX + 'px';
		}
	});

	document.addEventListener('mouseup', function() {
		thElm = undefined;
	});
}

export function commaSeparated(value) {
	if (typeof value !== 'number') {
		return value;
	}
	let val = (value / 1).toFixed(0);
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function toCurrency(value) {
	if (typeof value !== 'number') {
		return value;
	}
	let val = (value / 1).toFixed(2);
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function convertFalsyToNull(value) {
	if (typeof value === 'string') value = value.trim();
	if (!value) value = null;

	return value;
}

export function convertFalsyToEmpty(value) {
	if (typeof value === 'string') value = value.trim();
	if (!value) value = '';

	return value;
}

export function fixDecimalPlace(value, digit) {
	if (typeof value !== 'number' || typeof digit !== 'number') return value;
	return Number((value / 1).toFixed(digit));
}

export function inputSelectOnClick() {
	$("input[type='text'], input[type='number']").on('click', function() {
		$(this).select();
	});
}

export function emailRegExp(email) {
	const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
	return regExp.test(email);
}

// 요청 uri에 특수문자가 존재하는 경우 사용
export function encode(val) {
	return encodeURIComponent(val)
		.replace(/%40/gi, '@')
		.replace(/%3A/gi, ':')
		.replace(/%24/g, '$')
		.replace(/%2C/gi, ',')
		.replace(/%20/g, '+')
		.replace(/%5B/gi, '[')
		.replace(/%5D/gi, ']');
}

// ZPL
export function zplPrint(zplCommand) {
	var printWindow = window.open();
	printWindow.document.open('text/plain');
	printWindow.document.write(zplCommand);
	printWindow.document.close();
	printWindow.focus();
	printWindow.print();
	printWindow.close();
}

export function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

export function shallowCopy(target, except_props) {
	if (!target) return target;

	const obj = {};
	const keys = Object.keys(target);
	let isExcept = null;
	if (Array.isArray(except_props)) {
		isExcept = function(k) {
			return except_props.some(p => p === k);
		};
	} else {
		isExcept = function(k) {
			return except_props === k;
		};
	}

	for (const key of keys) {
		if (!isExcept(key)) obj[key] = target[key];
	}

	return obj;
}
